import React from 'react';

export function MessageQuestionHeaderIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M14.167 15.3582H10.8337L7.12532 17.8249C6.57532 18.1916 5.83366 17.7999 5.83366 17.1332V15.3582C3.33366 15.3582 1.66699 13.6916 1.66699 11.1916V6.19157C1.66699 3.69157 3.33366 2.0249 5.83366 2.0249H14.167C16.667 2.0249 18.3337 3.69157 18.3337 6.19157V11.1916C18.3337 13.6916 16.667 15.3582 14.167 15.3582Z"
        fill="#12B76A"
      />
      <path
        d="M9.99952 10.0916C9.65786 10.0916 9.37452 9.80822 9.37452 9.46655V9.29159C9.37452 8.32492 10.0828 7.84991 10.3495 7.66658C10.6578 7.45824 10.7578 7.31658 10.7578 7.09991C10.7578 6.68325 10.4162 6.34155 9.99952 6.34155C9.58286 6.34155 9.24121 6.68325 9.24121 7.09991C9.24121 7.44158 8.95788 7.72491 8.61621 7.72491C8.27454 7.72491 7.99121 7.44158 7.99121 7.09991C7.99121 5.99158 8.89119 5.09155 9.99952 5.09155C11.1079 5.09155 12.0078 5.99158 12.0078 7.09991C12.0078 8.04991 11.3079 8.5249 11.0495 8.6999C10.7245 8.91657 10.6245 9.05825 10.6245 9.29159V9.46655C10.6245 9.81655 10.3412 10.0916 9.99952 10.0916Z"
        fill="#12B76A"
      />
      <path
        d="M10 12.1667C9.65 12.1667 9.375 11.8834 9.375 11.5417C9.375 11.2001 9.65833 10.9167 10 10.9167C10.3417 10.9167 10.625 11.2001 10.625 11.5417C10.625 11.8834 10.35 12.1667 10 12.1667Z"
        fill="#12B76A"
      />
    </svg>
  );
}
